
import { LoginPage } from "../pages/login/login";
import { RegisterPage } from "../pages/register/register";
import { SubscriptionsPage } from "../pages/subscriptions/subscriptions";

import { NgModule, ErrorHandler } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { IonicApp, IonicModule, IonicErrorHandler } from "ionic-angular";
import { MyApp } from "./app.component";

import { AboutPage } from "../pages/about/about";
import { TabsPage } from "../pages/tabs/tabs";
import { AccountPage } from "../pages/account/account";
import { HistoryPaymentPage } from "../pages/history-payment/history-payment";
import { SendFeedbackPage } from "../pages/send-feedback/send-feedback";

import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";

import { BooksOnlinePage } from "../pages/books-online/books-online";
import { BookDetailPage } from "../pages/book-detail/book-detail";
import { BooksLocalPage } from "../pages/books-local/books-local";

import { PopOverOptionComponent } from "../components/pop-over-option/pop-over-option";
import { PopoverSettingComponent } from "../components/popover-settings/popover-settings";

// Firebase
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "angularfire2/firestore";

import { firebasConfig } from "./credentials";
import { AuthService } from "../services/auth.service";
import { FirebaseService } from "../services/firebase.service";
import { Firebase } from "@ionic-native/firebase/ngx";
import { AngularFireAuthModule } from "angularfire2/auth";

//Lettore ePub
import { BookPage } from "../pages/BOOK-READER/book/book";
import { Highlights } from "../pages/BOOK-READER/highlights/highlights";
import { Bookmarks } from "../pages/BOOK-READER/bookmarks/bookmarks";
import { TableOfContentsPage } from "../pages/BOOK-READER/table-of-contents/table-of-contents";
import { SettingsPage } from "../pages/BOOK-READER/settings/settings";
//import { DbService } from "../providers/db-service";
//import { ParseBook } from "../providers/parse-db-book";
//import { SQLite } from "@ionic-native/sqlite";
import { IonicStorageModule } from "@ionic/storage";

//import { FileTransfer, FileTransferObject } from "@ionic-native/file-transfer";
//import { File } from "@ionic-native/file";

import { DatePipe } from "@angular/common";



import { NetworkProvider } from '../providers/network/network';
import { Network } from '@ionic-native/network';
import { MybookDetailPage } from '../pages/mybook-detail/mybook-detail';
import { PaypalPage } from "../pages/paypal/paypal";
import { TermPage } from "../pages/term/term";

@NgModule({
  declarations: [
    MyApp,
    LoginPage,
    RegisterPage,
    SubscriptionsPage,
    AboutPage,
    AccountPage,
    BooksLocalPage,
    BooksOnlinePage,
    BookDetailPage,
    MybookDetailPage,
    PopOverOptionComponent,
    PopoverSettingComponent,
    TabsPage,
    HistoryPaymentPage,
    BookPage,
    Highlights,
    Bookmarks,
    TableOfContentsPage,
    SettingsPage,
    SendFeedbackPage,
    PaypalPage,
    TermPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: '',
      iconMode: "ios",
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      pageTransition: 'ios-transition',
      tabsHideOnSubPages: true
    }),
    AngularFireModule.initializeApp(firebasConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    IonicStorageModule.forRoot()
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    LoginPage,
    RegisterPage,
    SubscriptionsPage,
    AboutPage,
    AccountPage,
    BooksLocalPage,
    BooksOnlinePage,
    BookDetailPage,
    MybookDetailPage,
    PopOverOptionComponent,
    PopoverSettingComponent,
    TabsPage,
    HistoryPaymentPage,
    BookPage,
    Highlights,
    Bookmarks,
    TableOfContentsPage,
    SettingsPage,
    SendFeedbackPage,
    PaypalPage,
    TermPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    AuthService,
    FirebaseService,
    Firebase,
    //DbService,
    //ParseBook,
    //SQLite,
    // Storage,
    //FileTransfer,
    //FileTransferObject,
    //File,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    DatePipe,
    Network,
    NetworkProvider
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts